<template>
    <div class="calendar-overview-root">
        <Header :label="$t('calendar.header')" overlap="small" />
        <UserNavSection />

        <MainLayout marginTop>
            <ProfileModule slot="right" />
            <FeaturedResource slot="right" />
            <VerifyModule slot="right" />
            <div slot="center">
                <SectionHeader slot="center" style="position:relative">
                    <Breadcrumb slot="left" :trace="breadcrumb" />
                </SectionHeader>
                <div v-if="profileLoading" slot="center" class="w-100">
                    <Spinner class="loading-spinner mt-5" />
                </div>
                <div v-else-if="!hasCalendar" slot="center">
                    <NoContent :caption="$t('calendar.noCalendar')"></NoContent>
                    <BaseButton
                        id="backButton"
                        class="w-100"
                        variant="primary"
                        style="margin-top:20px;"
                        @click="handleGoBack"
                    >
                        {{ $t('calendar.goBackBtn') }}
                    </BaseButton>
                </div>
                <div
                    v-else-if="!hasCompletedProfile"
                    slot="center"
                    class="w-100 d-flex flex-column align-items-center pb-5"
                >
                    <img
                        :src="profileSvg"
                        style="display:block;margin:auto;width:200px;height:200px;object-fit:scale-down;margin-top:40px;"
                    />
                    <h6 class="text-center mb-4">
                        {{ $t('calendar.completedYourProfile') }}
                    </h6>
                    <BaseButton variant="primary" @click="toProfile">
                        {{ $t('calendar.toMyProfile') }}
                    </BaseButton>
                </div>
                <div v-else slot="center">
                    <Paper tall class="calendar-mycalendar-wrapper">
                        <div v-if="isLoading()" class="py-2">
                            <ListItemSkeleton v-for="i in 3" :key="i" :rows="3" small />
                        </div>
                        <AvailableAppointments v-for="data in types" :key="data.id" :data="data" />
                    </Paper>
                </div>
                <!--<div slot="center">
                <BaseButton
                    id="backButton"
                    class="w-100"
                    variant="outline-primary"
                    @click="handleBackClick"
                >
                    {{ $t('calendar.backToCalendarBtn') }}
                </BaseButton>
            </div> -->
            </div>
        </MainLayout>
    </div>
</template>

<script>
// Components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import UserNavSection from '~/shared/UserNavSection';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import VerifyModule from '~/components/miscellaneous/VerifyModule';
import FeaturedResource from '~/components/smart/FeaturedResource';
import NoContent from '~/components/miscellaneous/NoContent';

import Paper from '~/components/builders/Paper';

// Assets

import EmptySvg from '~/assets/img/empty.svg';
import AvailableAppointments from './components/AvailableAppointments';
import SectionHeader from '~/components/layouts/SectionHeader';
import Breadcrumb from '../../../shared/Breadcrumb';
import ListItemSkeleton from '~/components/skeletons/ListItemSkeleton';

import URLS from '~/URLS';
import i18n from '~/i18n';
import UniversityService from '~/services/UniversityService';
import { maxPossibleScore, getCurrentScore } from '~/utils/mappers/mapProfileToActions';
import ProfileSvg from '~/assets/img/profile.svg';

export default {
    name: 'AppointmentList',
    components: {
        ListItemSkeleton,
        Breadcrumb,
        AvailableAppointments,
        Paper,
        Header,
        UserNavSection,
        MainLayout,
        ProfileModule,
        VerifyModule,
        FeaturedResource,
        SectionHeader,
        NoContent,
    },
    data: () => ({
        emptyImage: EmptySvg,
        profileSvg: ProfileSvg,
        breadcrumb: [
            // My calendar is disabled in mvp
            // {
            //     exact: true,
            //     text: i18n.t('calendar.myCalendar'),
            //     to: URLS.calendar,
            // },
            {
                exact: true,
                text: i18n.t('calendar.bookAnAppointment'),
                to: URLS.calendar.concat(URLS.book),
            },
        ],
        types: [],
        loading: true,
    }),
    computed: {
        hasCompletedProfile() {
            const userData = this.userData() || {};
            const profileData = this.candidateData() || {
                languages: [],
                degrees: [],
            };
            return getCurrentScore(userData, profileData) >= maxPossibleScore;
        },
        profileLoading() {
            return this.loading || this.userLoading() || this.candidateLoading();
        },
        user() {
            return this.$interfaces.user.me.get({
                reactive: true,
            });
        },
        candidate() {
            return this.$interfaces.candidate.me.get({
                reactive: true,
            });
        },
        hasCalendar() {
            return this.types.length > 0;
        },
    },
    methods: {
        handleBackClick() {
            this.$router.push(this.$URLS.calendar);
        },
        isLoading() {
            return this.loading;
        },
        userLoading() {
            return this.user.loading;
        },
        candidateLoading() {
            return this.candidate.loading;
        },
        userData() {
            return this.user.data;
        },
        candidateData() {
            return this.candidate.data;
        },
        toProfile() {
            this.$router.push(this.$URLS.spotlight);
        },
        handleGoBack() {
            this.$router.back();
        },
    },
    async mounted() {
        //TODO REFACTOR: Create a "calendarService", see ResourceService as an example.
        await UniversityService.getCurrentSchoolData().then(data => {
            if (data.id) {
                this.$interfaces.calendar.type
                    .get({
                        school_id: data.id,
                    })
                    .then(data => {
                        this.types = data.data.results.filter(item => {
                            if (item && item.start && item.end) {
                                let now = new Date();
                                let start = new Date(item.start);
                                let end = new Date(item.end);
                                if (start < now && end < now) {
                                    return false;
                                }
                            }
                            return true;
                        });
                        this.loading = false;
                    });
            }
        });
    },
};
</script>

<style scoped></style>
